module.exports = __webpack_public_path__ + "static/media/item-border-selected.696661a6.svg";